// Campo de texto editable in situ — click en "Editar" muestra un input,
// Guardar persiste vía PATCH /assets/{id}/quick-update (mismo endpoint que
// el resto de ediciones ligeras de la ficha). Reutilizado por ID Finca,
// Juzgado, Procedimiento y Notas de subasta.
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const InlineTextField = ({ assetId, field, value, label, placeholder = '—', editable, onSaved, testid, multiline = false, hideWhenEmpty = false }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value || '');
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (!editing) setDraft(value || ''); }, [value, editing]);

  const save = async () => {
    const v = draft.trim();
    if (v === (value || '')) { setEditing(false); return; }
    setSaving(true);
    try {
      const r = await axios.patch(`${API}/assets/${assetId}/quick-update`, { [field]: v || null }, { withCredentials: true });
      toast.success('Cambio guardado');
      setEditing(false);
      if (onSaved) onSaved(r.data?.asset || null);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo guardar');
      setDraft(value || '');
    } finally { setSaving(false); }
  };

  if (!editing) {
    if (hideWhenEmpty && !value) {
      return editable ? (
        <button type="button" className="block text-xs text-blue-600 hover:underline py-1" data-testid={`${testid}-add-btn`}
          onClick={() => { setDraft(''); setEditing(true); }}>+ Añadir {label.toLowerCase()}</button>
      ) : null;
    }
    return (
      <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-2 border-b border-slate-100 min-w-0 last:border-b-0" data-testid={testid}>
        <span className="text-slate-500 shrink-0">{label}</span>
        <div className="flex items-center gap-2 min-w-0 sm:justify-end">
          <span className="font-medium min-w-0 sm:text-right [overflow-wrap:anywhere]" data-testid={`${testid}-value`}>{value || placeholder}</span>
          {editable && (
            <button type="button" className="text-xs text-blue-600 hover:underline shrink-0" data-testid={`${testid}-edit-btn`}
              onClick={() => { setDraft(value || ''); setEditing(true); }}>Editar</button>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-2 py-2 border-b border-slate-100 last:border-b-0" data-testid={testid}>
      <span className="text-slate-500">{label}</span>
      {multiline
        ? <textarea autoFocus rows={3} className="input-base w-full text-sm" value={draft} disabled={saving}
            onChange={(e) => setDraft(e.target.value)} data-testid={`${testid}-input`} />
        : <input autoFocus type="text" className="input-base w-full text-sm" value={draft} disabled={saving}
            onChange={(e) => setDraft(e.target.value)} data-testid={`${testid}-input`} />}
      <div className="flex gap-2 justify-end">
        <button type="button" className="btn-secondary text-xs" disabled={saving} data-testid={`${testid}-cancel`}
          onClick={() => { setDraft(value || ''); setEditing(false); }}>Cancelar</button>
        <button type="button" className="btn-primary text-xs" disabled={saving} data-testid={`${testid}-save`} onClick={save}>Guardar</button>
      </div>
    </div>
  );
};

export const InlineSelectField = ({ assetId, field, value, label, options, placeholder = '—', editable, onSaved, testid, disabledTitle, hideWhenEmpty = false }) => {
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const currentLabel = (options.find((o) => o.v === value) || {}).l;

  const save = async (v) => {
    setSaving(true);
    try {
      const r = await axios.patch(`${API}/assets/${assetId}/quick-update`, { [field]: v || null }, { withCredentials: true });
      toast.success('Cambio guardado');
      setEditing(false);
      if (onSaved) onSaved(r.data?.asset || null);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo guardar');
    } finally { setSaving(false); }
  };

  if (!editable || disabledTitle) {
    if (hideWhenEmpty && !value) return null;
    return (
      <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-2 border-b border-slate-100 min-w-0 last:border-b-0" data-testid={testid} title={disabledTitle}>
        <span className="text-slate-500 shrink-0">{label}</span>
        <span className="font-medium min-w-0 sm:text-right" data-testid={`${testid}-value`}>{currentLabel || value || placeholder}</span>
      </div>
    );
  }
  if (hideWhenEmpty && !value && !editing) {
    return (
      <button type="button" className="block text-xs text-blue-600 hover:underline py-1" data-testid={`${testid}-add-btn`}
        onClick={() => setEditing(true)}>+ Añadir {label.toLowerCase()}</button>
    );
  }
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between gap-2 py-2 border-b border-slate-100 min-w-0 last:border-b-0" data-testid={testid}>
      <span className="text-slate-500 shrink-0">{label}</span>
      {editing
        ? <select autoFocus disabled={saving} defaultValue={value || ''} className="text-sm rounded border px-2 py-1 sm:ml-auto"
            onBlur={() => { if (!saving) setEditing(false); }} onChange={(e) => save(e.target.value)} data-testid={`${testid}-select`}>
            <option value="">— sin valor —</option>
            {options.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
          </select>
        : <button type="button" className="font-medium min-w-0 sm:text-right text-blue-600 hover:underline" data-testid={`${testid}-value`}
            onClick={() => setEditing(true)}>{currentLabel || value || placeholder}</button>}
    </div>
  );
};
